module.exports = __webpack_public_path__ + "static/media/home-and-cook-101x101.89882506.jpg";